// extracted by mini-css-extract-plugin
module.exports = {"container":"UserCard_container__KjLn0","content":"UserCard_content__1LjRS"};